<!-- DSOrderDetailTitleData.vue -->
<template>
  <el-row class="orderDetailTitleData">
    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
      <ul>
        <li><span>订单ID</span>：{{ titleData.ORDER_ID }}</li>
        <li><span>订单编号</span>：{{ titleData.ORDER_CODE }}</li>
        <li><span>送货日期</span>：{{ titleData.SEND_DATE }}</li>
        <li><span>总金额</span>：{{ titleData.TOTAL_FEE }}</li>
      </ul>
    </el-col>
    <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
      <ul>
        <li><span>供应商</span>：{{ titleData.SUPPLIER_NAME }}</li>
        <li><span>客户</span>：{{ titleData.CUSTOMER_NAME }}</li>
        <li><span>项目点</span>：{{ titleData.PROJECT_NAME }}</li>
        <li><span>档口</span>：{{ titleData.DK_NAME }}</li>
      </ul>
    </el-col>
  </el-row>
</template>
<script>

export default {
  props: {
    titleData: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/DSOrder/DSOrderDetailTitleData.vue